import axios from 'axios';

import {
  parseCancelDpiaRequestForBE,
  parseDecideDpiaRequestForBE,
  parseDpiaRequestForFE,
  parseDpiaRequestOpenResponseForFE,
  parseOpenDpiaRequestForBE,
  parseSaveDpiaRequestDraftForBE,
} from './dpiaRequests.parsers';
import type {
  CancelDpiaRequestInput,
  DecideDpiaRequestInput,
  DpiaRequestDTO,
  DpiaRequestOpenResponseDTO,
  DpiaRequestsApi,
  OpenDpiaRequestInput,
  SaveDpiaRequestDraftInput,
} from './dpiaRequests.types';

const buildOpenEndpoint = (organizationId: number, assetProcessingActivityId: number) =>
  `api/v1/organizations/${organizationId}/asset-processing-activities/${assetProcessingActivityId}/dpia-requests/open/`;

const buildRequestEndpoint = (organizationId: number, requestId: number) =>
  `api/v1/organizations/${organizationId}/dpia-requests/${requestId}/`;

const buildDecideRequiredEndpoint = (organizationId: number, requestId: number) =>
  `${buildRequestEndpoint(organizationId, requestId)}decide-required/`;

const buildDecideNotRequiredEndpoint = (organizationId: number, requestId: number) =>
  `${buildRequestEndpoint(organizationId, requestId)}decide-not-required/`;

const buildCancelEndpoint = (organizationId: number, requestId: number) => `${buildRequestEndpoint(organizationId, requestId)}cancel/`;

export const dpiaRequestsApi: DpiaRequestsApi = {
  openRequest: async (organizationId, assetProcessingActivityId, payload: OpenDpiaRequestInput = {}) => {
    const { data } = await axios.post<DpiaRequestOpenResponseDTO | DpiaRequestDTO>(
      buildOpenEndpoint(organizationId, assetProcessingActivityId),
      parseOpenDpiaRequestForBE(payload),
    );
    const parsed = parseDpiaRequestOpenResponseForFE(data);
    if (!parsed.request.id) {
      throw new Error('DPIA need assessment response is missing request id');
    }
    return { data: parsed };
  },
  getRequest: async (organizationId, requestId) => {
    const { data } = await axios.get<DpiaRequestOpenResponseDTO | DpiaRequestDTO>(buildRequestEndpoint(organizationId, requestId));
    return { data: parseDpiaRequestOpenResponseForFE(data) };
  },
  saveDraft: async (organizationId, requestId, payload: SaveDpiaRequestDraftInput) => {
    const { data } = await axios.patch<DpiaRequestDTO>(
      buildRequestEndpoint(organizationId, requestId),
      parseSaveDpiaRequestDraftForBE(payload),
    );
    return { data: parseDpiaRequestForFE(data) };
  },
  decideRequired: async (organizationId, requestId, payload: DecideDpiaRequestInput) => {
    const { data } = await axios.post<DpiaRequestOpenResponseDTO | DpiaRequestDTO>(
      buildDecideRequiredEndpoint(organizationId, requestId),
      parseDecideDpiaRequestForBE(payload),
    );
    return { data: parseDpiaRequestOpenResponseForFE(data) };
  },
  decideNotRequired: async (organizationId, requestId, payload: DecideDpiaRequestInput) => {
    const { data } = await axios.post<DpiaRequestOpenResponseDTO | DpiaRequestDTO>(
      buildDecideNotRequiredEndpoint(organizationId, requestId),
      parseDecideDpiaRequestForBE(payload),
    );
    return { data: parseDpiaRequestOpenResponseForFE(data) };
  },
  cancelRequest: async (organizationId, requestId, payload: CancelDpiaRequestInput) => {
    const { data } = await axios.post<DpiaRequestDTO>(buildCancelEndpoint(organizationId, requestId), parseCancelDpiaRequestForBE(payload));
    return { data: parseDpiaRequestForFE(data) };
  },
};

export default dpiaRequestsApi;
